import { CoreModule } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { PrimengSharedModule } from './primeng-shared.module';

import { NgxCurrencyDirective } from 'ngx-currency';
import { GiptBoxComponent } from '../main/wishlist/fan-view/gipt-box/gipt-box.component';
import { SuccessConfirmationPopupComponent } from '../main/wishlist/shared/success-confirmation-popup/success-confirmation-popup.component';
import { FooterComponent } from '../page/footer/footer.component';
import { HeaderMenuComponent } from '../page/header-menu/header-menu.component';
import { ConfirmBlockUserComponent } from './components/confirm-block-user/confirm-block-user.component';
import { ConfirmChangeProfileComponent } from './components/confirm-change-profile/confirm-change-profile.component';
import { DeliveryStepProgressComponent } from './components/delivery-step-progress/delivery-step-progress.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { ReportUserComponent } from './components/report-user/report-user.component';
import { LabelValidationComponent } from './dft/component/lable-validate.component';
import { PopupConfirmComponent } from './dft/component/popup-confirm/popup-confirm.component';
import { ValidationComponent } from './dft/component/validation-messages.component';
import { JapanesePhoneNumberDirective } from './dft/directives/japanese-phone-number.service';
import { NumbersOnlyDirective } from './dft/directives/only-number.directive';
import { DatePipe } from './dft/pipe/date.pipe';
import { JapanDatePipe } from './dft/pipe/japan-date.pipe';
import { TienTePipe } from './dft/pipe/tiente.pipe';
import { TimeAgoPipe } from './dft/pipe/time-ago.pipe';
import { UserFollowFormatPipe } from './dft/pipe/user-follow.pipe';

@NgModule({
  declarations: [
    ValidationComponent,
    LabelValidationComponent,
    TienTePipe,
    TimeAgoPipe,
    UserFollowFormatPipe,
    JapanDatePipe,
    NumbersOnlyDirective,
    JapanesePhoneNumberDirective,
    PopupConfirmComponent,
    FooterComponent,
    HeaderMenuComponent,
    GiptBoxComponent,
    OnboardingComponent,
    DeliveryStepProgressComponent,
    ConfirmChangeProfileComponent,
    ConfirmBlockUserComponent,
    ReportUserComponent,
    DatePipe,
    SuccessConfirmationPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    NgbDropdownModule,
    PrimengSharedModule,
    ButtonModule,
    ProgressBarModule,
    DynamicDialogModule,
    InputTextModule,
    SidebarModule,
    ToastModule,
    NgxCurrencyDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    NgbDropdownModule,
    PrimengSharedModule,
    ButtonModule,
    ProgressBarModule,
    DynamicDialogModule,
    InputTextModule,
    SidebarModule,
    ToastModule,
    ValidationComponent,
    LabelValidationComponent,
    FooterComponent,
    HeaderMenuComponent,
    GiptBoxComponent,
    TienTePipe,
    TimeAgoPipe,
    UserFollowFormatPipe,
    JapanDatePipe,
    JapanesePhoneNumberDirective,
    NgxCurrencyDirective,
    NumbersOnlyDirective,
    OnboardingComponent,
    DeliveryStepProgressComponent,
    ConfirmChangeProfileComponent,
    ConfirmBlockUserComponent,
    ReportUserComponent,
    DatePipe,
    SuccessConfirmationPopupComponent
  ],
  providers: []
})
export class SharedModule { }
